import PropTypes from 'prop-types';
import React from 'react';
import { AuthorProps } from '../../Includes/AuthorProps';
import { GroupCondensedPropShape } from '../../Includes/GroupPropsShape';
import { SingleContentTopicProps } from '../../Includes/TopicPropsShape';
import { getFormattedTimestamp } from '../../Utilities/TimeFunctions';
import CreatorComponent from '../CreatorComponent/CreatorComponent';
import './CommonCard.scss';

export default class CommonCard extends React.PureComponent {
    constructor(props) {
        super();
    }

    static propTypes = {
        /**
         * Author props
         */
        author: PropTypes.shape(AuthorProps),
        /**
         * topic props
         */
        topic: PropTypes.shape(SingleContentTopicProps),
        /**
         * object of a group
         */
        group: PropTypes.shape(GroupCondensedPropShape),
        /**
         * reaction bar
         */
        reactionBar: PropTypes.node,
        /**
         * content has
         */
        contentHash: PropTypes.string.isRequired,
        /**
         * time created
         */
        time: PropTypes.string,
        /**
         * string of content creation date
         */
        streamDate: PropTypes.string,
    };

    static defaultProps = {
        showAuthor: true,
    };

    render() {
        return (
            <div className="component-Content-CommonCard">
                {this.props.showAuthor && (
                    <CreatorComponent
                        author={this.props.author}
                        time={this.props.time}
                        topic={this.props.topic}
                        group={this.props.group}
                        contentHash={this.props.contentHash}
                        formattedTimestamp={
                            this.props.streamDate
                                ? getFormattedTimestamp(this.props.streamDate)
                                : ''
                        }
                    />
                )}
                {this.props.children}
                {this.props.reactionBar || null}
            </div>
        );
    }
}
